<template>
    <MenuBase :hidden="props.hidden"   
        tooltip="Share playlist" 
        :tooltipPosition="props.tooltipPosition" 
        :theme="props.theme" 
        :tooltipText="props.tooltipText"
        :active="active"
        @click="sharePlaylist()" >
        <ShareIcon class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { ShareIcon } from '@heroicons/vue/24/outline';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['sharePlaylist'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    }
})

const sharePlaylist = () => {
    emit('sharePlaylist');
    appEvents.emit('sharePlaylist');
}
</script>